import { CssBaseline } from "@mui/material";
import { StyledEngineProvider } from "@mui/material/styles";
import * as React from "react";
import * as ReactDOM from "react-dom/client";
import "./index.css";

import App from "./App";
import reportWebVitals from "./reportWebVitals";
import ThemeProvider from "./theme/index";
import { Provider } from "react-redux";
import { store } from "./redux/store";

const rootElement = document.getElementById("root");
const root = ReactDOM.createRoot(rootElement!);

root.render(
    <React.StrictMode>
        <StyledEngineProvider injectFirst>
            <React.Suspense>
                <ThemeProvider>
                    <Provider store={store}>
                        <CssBaseline />
                        <App />
                    </Provider>
                </ThemeProvider>
            </React.Suspense>
        </StyledEngineProvider>
    </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
